import styled from 'styled-components';

export const StyledSankeyHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 10px;

  h3 {
    margin: 0;
    text-align: left;
  }
`;
